import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
    return (
        <nav className="sticky-nav">
            <div className="container nav-container">
                <Link to="/" className="nav-brand">
                    <span className="nav-brand-text">
                        <span className="nav-brand-product">Panda</span>
                        <span className="nav-brand-by">by Steepwind Labs</span>
                    </span>
                </Link>
                <div className="nav-links">
                    <a href="/#features" className="nav-item">Product</a>
                    <a href="/#pricing" className="nav-item">Pricing</a>
                    <Link to="/team" className="nav-item">About Us</Link>
                    <Link to="/privacy-policy" className="nav-item">Terms</Link>
                </div>
                <a
                    href="https://play.google.com/store/apps/details?id=com.blurr.voice"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-cta"
                >
                    Download App
                </a>
            </div>
        </nav>
    );
}

export default Navbar;
